export default __webpack_public_path__ + "static/welcome-df9074cc1e894f0d962e6062877448aa.svg";